import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import DesktopExperienceSharePage from './DesktopExperienceSharePage';
import MobileExperienceSharePage from './MobileExperienceSharePage';

import { DeviceContext, deviceType } from '@providers';

interface RouteParams {
  slug: string;
  id: string;
}

const ExperienceSharePage = () => {
  const location = useLocation();
  const { slug, id } = useParams<RouteParams>();
  const { isMobile } = useContext<deviceType>(DeviceContext);

  const [deepLink, setDeepLink] = useState('');

  useEffect(() => {
    // Create Branch link
    const linkData = {
      data: {
        $deeplink_path: location.pathname,
      },
    };

    // @ts-ignore
    branch.link(linkData, (err, link) => {
      if (!err) {
        setDeepLink(link);
      }
    });
  }, [id, slug]);

  return isMobile ? (
    <MobileExperienceSharePage deepLink={deepLink} />
  ) : (
    <DesktopExperienceSharePage deepLink={deepLink} />
  );
};

export default ExperienceSharePage;
